var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email",
    d: "M20,3H4A4.012,4.012,0,0,0,0,7V17a4.012,4.012,0,0,0,4,4H20a4.012,4.012,0,0,0,4-4V7A4.012,4.012,0,0,0,20,3Zm1.6,5.8-7.9,5.3a3.371,3.371,0,0,1-1.7.5,3.371,3.371,0,0,1-1.7-.5L2.4,8.8a1.058,1.058,0,0,1-.2-1.4,1.058,1.058,0,0,1,1.4-.2l7.9,5.3a1.083,1.083,0,0,0,1.1,0l7.9-5.3a.984.984,0,0,1,1.4.3A1.091,1.091,0,0,1,21.6,8.8Z",
    fill: "#0f43cc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.a2f03f5fc390536fb06931e425fc35d3.svg";
export { ForwardRef as ReactComponent };